import { container } from "tsyringe";
import type { App } from "vue";
import { CORE_INITIALIZER, CORE_PLUGIN, type Initializer } from "./core";
import "./plugins";
import type { Plugin } from "./plugins";

export class Application {
  app: App<Element>;
  constructor(app: App<Element>) {
    this.app = app;
  }

  run() {
    /**
     * 初始化基础的Vue相关的“设施”，为插件阶段做准备
     */
    const initializers = container.resolveAll<Initializer>(CORE_INITIALIZER);
    initializers.forEach((i) => i.start(this.app));

    /**
     * 调用所有引入的插件
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const plugins = container.resolveAll<Plugin<any, any>>(CORE_PLUGIN);

    plugins.forEach((i) => i.init(this.app));
    // 插件后处理
    plugins.forEach((i) => i.initialized(this.app));

    // 初始化器后处理
    initializers.forEach((i) => i.started(this.app));

    this.app.mount("#app");
  }
}
